import { SidebarMenuItem } from '@backrs_ui/common-ui';

import { APP_ROUTE } from '@backrs_ui/grow-ui/src/App';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { SectionDependencies } from './menuSections.hook';

const BACKRS_APP_URL = process.env.REACT_APP_BACKRS_URL;
const BOTTOM_SECTION_TITLES = appStrings.modules.backrsPageShell.menuItems.bottom;

export const bottomSection = ({
  navigate,
  location,
  userPermissions,
  isUnauthenticated,
}: SectionDependencies): SidebarMenuItem[] => {
  return [
    {
      title: BOTTOM_SECTION_TITLES.supercoach,
      hidden: !userPermissions?.access_super_coach.allowed,
      leftIcon: { iconName: 'Glasses02' },
      variant: {
        isActive: location.pathname === APP_ROUTE.OFFICE_HOURS_SUPERCOACH,
        type: 'NAVIGATION_ITEM',
        onClick: () => navigate(APP_ROUTE.OFFICE_HOURS_SUPERCOACH),
      },
    },
    {
      title: BOTTOM_SECTION_TITLES.superuser,
      hidden: !userPermissions?.access_super_user.allowed,
      leftIcon: { iconName: 'UserUp02' },
      variant: {
        isActive: location.pathname === APP_ROUTE.OFFICE_HOURS_SUPERUSER,
        type: 'NAVIGATION_ITEM',
        onClick: () => navigate(APP_ROUTE.OFFICE_HOURS_SUPERUSER),
      },
    },
    {
      title: BOTTOM_SECTION_TITLES.prosper,
      hidden: isUnauthenticated,
      leftIcon: { iconName: 'CheckDone01' },
      variant: {
        isActive: location.pathname === APP_ROUTE.PROSPER,
        type: 'NAVIGATION_ITEM',
        onClick: () => navigate(APP_ROUTE.PROSPER),
      },
    },
    {
      title: BOTTOM_SECTION_TITLES.connect,
      hidden: isUnauthenticated,
      leftIcon: { iconName: 'Dataflow01', rotate: 90 },
      variant: {
        type: 'EXPANDABLE',
        subItems: [
          {
            title: BOTTOM_SECTION_TITLES.catchUp,
            variant: {
              type: 'NAVIGATION_ITEM',
              isActive: false,
              isSubItem: true,
              onClick: () => window.open(`${BACKRS_APP_URL}/catchup`, '_blank'),
            },
          },
          {
            title: BOTTOM_SECTION_TITLES.networks,
            variant: {
              type: 'NAVIGATION_ITEM',
              isActive: false,
              isSubItem: true,
              onClick: () => window.open(`${BACKRS_APP_URL}/tabs/feed`, '_blank'),
            },
          },
          {
            title: BOTTOM_SECTION_TITLES.panels,
            variant: {
              type: 'NAVIGATION_ITEM',
              isActive: false,
              isSubItem: true,
              onClick: () => window.open(`${BACKRS_APP_URL}/tabs/backrs/teams`, '_blank'),
            },
          },
        ],
      },
    },
  ];
};
